"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALERT = exports.REDIRECT = exports.LOADING = exports.LANGUAGE = exports.THEME = exports.XHR_RESPONSE = exports.XHR_REQUEST = exports.EXTERNAL_LINK = exports.INTERNAL_LINK = exports.UX = exports.XHR_TIMING = exports.NAVIGATE_TIMING = exports.RENDER_TIMING = void 0;
var RENDER_TIMING = 'render_timing';
exports.RENDER_TIMING = RENDER_TIMING;
var NAVIGATE_TIMING = 'navigate_timing';
exports.NAVIGATE_TIMING = NAVIGATE_TIMING;
var XHR_TIMING = 'xhr_timing';
exports.XHR_TIMING = XHR_TIMING;
var UX = 'ux';
exports.UX = UX;
var INTERNAL_LINK = 'internal_link';
exports.INTERNAL_LINK = INTERNAL_LINK;
var EXTERNAL_LINK = 'external_link';
exports.EXTERNAL_LINK = EXTERNAL_LINK;
var XHR_REQUEST = 'xhr_request';
exports.XHR_REQUEST = XHR_REQUEST;
var XHR_RESPONSE = 'xhr_response';
exports.XHR_RESPONSE = XHR_RESPONSE;
var THEME = 'theme';
exports.THEME = THEME;
var LANGUAGE = 'language';
exports.LANGUAGE = LANGUAGE;
var LOADING = 'loading';
exports.LOADING = LOADING;
var REDIRECT = 'redirect';
exports.REDIRECT = REDIRECT;
var ALERT = 'alert';
exports.ALERT = ALERT;